<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 预警系统</el-breadcrumb-item>
                <el-breadcrumb-item>后端Api接口</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form v-show='showSearch' ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item prop='dictType' style='margin-bottom: 0'>
                                <el-input
                                    size='mini'
                                    v-model='queryParams.noticeAccount'
                                    clearable
                                    placeholder='请输入通知账号'
                                    style='width: 240px'
                                    @keyup.enter.native='handleQuery'
                                />
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select clearable filterable size='mini' v-model='queryParams.userId' placeholder='用户'>
                                    <el-option
                                        v-for='item in adminUserSelectList'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select clearable size='mini' v-model='queryParams.noticeAccountType'
                                           placeholder='通知账号类型'>
                                    <el-option
                                        v-for='item in userNoticeAccountTypeList'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select clearable size='mini' v-model='queryParams.authentication'
                                           placeholder='账号是否认证'>
                                    <el-option
                                        v-for='item in authenticationSelectList'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select clearable size='mini' v-model='queryParams.noticeLevel'
                                           placeholder='通知级别'>
                                    <el-option
                                        v-for='item in userNoticeLevel'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='2'>
                        <el-row class='mb8'>
                            <el-col :span='8'>
                                <el-button
                                    icon='el-icon-plus'
                                    plain
                                    size='mini'
                                    type='primary'
                                    @click='handleAdd'
                                >新增
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='userNoticeConfigList'
                      @selection-change='handleSelectionChange'>
                <!--<el-table-column align='center' type='selection' width='55' />-->
                <el-table-column :show-overflow-tooltip='true' align='center' label='用户'>
                    <template slot-scope='scope'>
                        <span>{{ adminUserSelectMap.get(scope.row.userId) }}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='通知账户' prop='noticeAccount' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='是否认证' prop='apiRequestType'>
                    <template slot-scope='scope'>
                        <el-tag size='mini' :type='scope.row.authentication ? "success" : "danger"'>
                            {{ scope.row.authentication ? '已认证' : '未认证' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='账号类型'>
                    <template slot-scope='scope'>
                        <span>{{ getAccountType(scope.row.noticeAccountType) }}</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='通知级别'>
                    <template slot-scope='scope'>
                        <span>{{ getNoticeLevel(scope.row.noticeLevel) }}</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='创建时间' prop='createTime' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='最后更新时间' prop='updateTime' />
                <el-table-column fixed='right' align='center' width='200' class-name='small-padding fixed-width'
                                 label='操作'>
                    <template slot-scope='scope'>
                        <el-button
                            icon='el-icon-edit'
                            size='mini'
                            type='text'
                            @click='handleUpdate(scope.row)'
                        >修改
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                        <el-button
                            icon='el-icon-unlock'
                            size='mini'
                            type='text'
                            @click='handleAccountVerify(scope.row)'
                        >账号认证
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='prev, pager, next'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改参数配置对话框 -->
            <el-dialog :title='title' :before-close='cancel' :visible.sync='open' append-to-body width='40%'>
                <el-form label-position='right' ref='form' label-width='100px'>
                    <el-form-item label='所属用户' prop='url'>
                        <el-select size='mini' v-model='currentUserNoticeConfig.userId' placeholder='请选择'>
                            <el-option
                                v-for='item in adminUserSelectList'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='通知级别' prop='url'>
                        <el-select size='mini' v-model='currentUserNoticeConfig.noticeLevel' placeholder='请选择'>
                            <el-option
                                v-for='item in userNoticeLevel'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop='url'>
                        <template slot='label'>
                            <span>通知账号</span>
                            <el-tooltip class='item' effect='dark'
                                        content='一个用户在一个通知级别下，只能对应一个通知账号' placement='top-start'>
                                <i class='el-icon-message-solid' />
                            </el-tooltip>
                        </template>
                        <el-tabs v-model='activeTabName' :before-leave='handleBeforeTab'>
                            <el-tab-pane label='短信' name='SMS'>
                                <el-input type='number' placeholder='请输入手机号'
                                          v-model='currentUserNoticeConfig.noticeAccount' size='mini' />
                            </el-tab-pane>
                            <el-tab-pane label='邮件' name='EMAIL'>
                                <el-input type='text' placeholder='请输入邮箱'
                                          v-model='currentUserNoticeConfig.noticeAccount' size='mini' />
                            </el-tab-pane>
                            <el-tab-pane label='QQ' name='QQ'>
                                <el-input type='number' placeholder='请输入QQ号'
                                          v-model='currentUserNoticeConfig.noticeAccount' size='mini' />
                                <el-alert
                                    style='margin-top: 1rem;'
                                    title='如果需要使用QQ机器人通知，请添加以下QQ号为机器人(最好添加所有机器人)，以及加入后端预警通知群'
                                    type='warning'
                                    :closable='false'>
                                </el-alert>
                                <el-row style='margin-top: 1rem;' :gutter='10'>
                                    <el-col :span='12' :xs='24'>
                                        <el-card shadow='never' class='box-card'>
                                            <span slot='header'>QQ机器人</span>
                                            <div v-for='(item, index) in qqMonitorData.qqBot'>
                                                <el-row :gutter='10'>
                                                    <el-col :span='14' :xs='24'>
                                                        <span>{{ item.qq }}</span>&nbsp;&nbsp;<el-badge
                                                        :type="item.online ? 'success' : 'danger'" is-dot
                                                        class='item' />
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </el-card>
                                    </el-col>
                                    <el-col :span='12' :xs='24'>
                                        <el-card shadow='never' class='box-card'>
                                            <span slot='header'>后端预警通知群</span>
                                            <div v-for='(item, index) in qqMonitorData.qqGroup'>
                                                <el-row :gutter='10'>
                                                    <el-col :span='14' :xs='24'>
                                                        <span>{{ item.groupId }}</span>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </el-card>
                                    </el-col>
                                </el-row>
                            </el-tab-pane>
                        </el-tabs>
                    </el-form-item>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </section>
</template>

<script>

import { message } from '@/utils/message';
import { deepCopy } from '@/utils/object';
import { queryQQMonitorData } from '@/components/api/Monitor/Monitor';
import { copyContent } from '@/utils/string/cottonPlugin';
import {
    deleteUserNoticeConfig,
    insertUserNoticeConfig,
    queryUserNoticeConfigList,
    resendAuthenticationInfo,
    updateUserNoticeConfig,
    verifyAccount
} from '@/components/api/UserNoticeConfig/UserNoticeConfig';
import { selectEmployeeList } from '@/components/api/dashboard';
import { REGEXP_CODE_SIX, REGEXP_EMAIL, REGEXP_PHONE } from '@/constant/regexEnums';

export default {
    name: 'Dict',
    data() {
        return {
            activeTabName: 'EMAIL',
            qqMonitorData: {},
            adminUserSelectList: [],
            adminUserSelectMap: new Map(),
            userNoticeLevel: [
                {
                    label: '一级预警',
                    value: 'HIGH'
                },
                {
                    label: '二级预警',
                    value: 'MIDDLE'
                },
                {
                    label: '三级预警',
                    value: 'LOW'
                }
            ],
            userNoticeAccountTypeList: [
                {
                    label: '邮箱',
                    value: 'EMAIL'
                },
                {
                    label: '短信',
                    value: 'SMS'
                },
                {
                    label: 'QQ',
                    value: 'QQ'
                }
            ],
            authenticationSelectList: [
                {
                    label: '未认证',
                    value: false
                },
                {
                    label: '已认证',
                    value: true
                }
            ],
            userNoticeTypeList: [
                {
                    label: '系统预警',
                    value: 'WARNING_NOTICE'
                }
            ],
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            batchDeleteStatus: false,
            // 显示搜索条件
            showSearch: true,
            userNoticeConfigList: [],
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                userId: undefined,
                noticeAccount: undefined,
                noticeAccountType: undefined,
                authentication: undefined,
                noticeType: undefined,
                noticeLevel: undefined,
                apiWarningLevel: undefined
            },
            updateStatus: false,
            currentUserNoticeConfig: {},
            originNoticeAccount: ''
        };
    },
    computed: {
        getAccountType() {
            return (noticeAccountType) => {
                switch (noticeAccountType) {
                    case 'EMAIL':
                        return '邮箱';
                    case 'SMS':
                        return '短信';
                    case 'QQ':
                        return 'QQ';
                    default:
                        return '未知';
                }
            };
        },
        getNoticeLevel() {
            return (noticeLevel) => {
                switch (noticeLevel) {
                    case 'HIGH':
                        return '一级通知';
                    case 'MIDDLE':
                        return '二级通知';
                    case 'LOW':
                        return '三级通知';
                    default:
                        return '未知';
                }
            };
        }
    },
    created() {
        this.getList();
        this.getEmployeeList();
        this.queryQQMonitorData();
    },
    methods: {
        handleChangeNoticeAccountType(type) {
            this.activeTabName = type;
        },
        handleBeforeTab(activeName, oldActiveName) {
            return true;
        },
        handleCopyNoticeUrl() {
            copyContent(this.alterWarningNoticeUrl);
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        /** 查询字典类型列表 */
        getList() {
            this.loading = true;
            queryUserNoticeConfigList(this.queryParams).then(response => {
                if (response.code === 200) {
                    this.userNoticeConfigList = response.data.result;
                    this.queryParams.total = response.data.total;
                    this.loading = false;
                    this.queryParams.pageNum = response.data.pageNum;
                } else {
                    this.loading = false;
                }
            });
        },
        getEmployeeList() {
            selectEmployeeList({ pageNum: 1 }).then(result => {
                if (result.code === 200) {
                    result.data.forEach(user => {
                        let account = user['account'];
                        let userId = user['userId'];
                        this.adminUserSelectMap.set(userId, account);
                        this.adminUserSelectList.push({
                            label: account,
                            value: userId
                        });
                    });
                }
            });
        },
        queryQQMonitorData() {
            queryQQMonitorData().then(result => {
                if (result.code === 200) {
                    this.qqMonitorData = result.data;
                }
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
            this.currentWhiteUrl = {};
            this.originNoticeAccount = '';
        },
        // 表单重置
        reset() {
        
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {};
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = '增加后端接口';
            this.updateStatus = false;
            this.currentUserNoticeConfig = {};
        },
        handleBatchDelete() {
            let idList = this.ids;
            const obj = this;
            
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id);
            this.batchDeleteStatus = this.ids.length > 0;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            this.open = true;
            this.title = '修改Api接口信息';
            this.updateStatus = true;
            this.currentUserNoticeConfig = deepCopy(row);
            this.activeTabName = row.noticeAccountType;
            this.originNoticeAccount = row.noticeAccount;
        },
        /** 提交按钮 */
        submitForm: function() {
            if (!this.currentUserNoticeConfig.userId) {
                message.warning('请选择所属用户');
                return;
            }
            if (!this.currentUserNoticeConfig.noticeLevel) {
                message.warning('通知级别不能为空');
                return;
            }
            if (!this.currentUserNoticeConfig.noticeAccount) {
                message.warning('通知账号不能为空');
                return;
            }
            this.currentUserNoticeConfig.noticeAccountType = this.activeTabName;
            this.currentUserNoticeConfig.noticeType = 'WARNING_NOTICE';
            if (this.currentUserNoticeConfig.noticeAccountType === 'EMAIL') {
                if (!REGEXP_EMAIL.test(this.currentUserNoticeConfig.noticeAccount)) {
                    message.warning('请输入正确的邮箱号');
                    return;
                }
            }
            if (this.currentUserNoticeConfig.noticeAccountType === 'SMS') {
                if (!REGEXP_PHONE.test(this.currentUserNoticeConfig.noticeAccount)) {
                    message.warning('请输入正确的手机号');
                    return;
                }
            }
            if (this.updateStatus) {
                updateUserNoticeConfig(this.currentUserNoticeConfig).then(result => {
                    if (result.code === 200) {
                        message.success('修改成功');
                        this.getList();
                        this.open = false;
                        this.handleAccountVerify(this.currentUserNoticeConfig);
                    }
                });
            } else {
                insertUserNoticeConfig(this.currentUserNoticeConfig).then(result => {
                    if (result.code === 200) {
                        message.success('添加成功');
                        this.getList();
                        this.open = false;
                        this.handleAccountVerify(this.currentUserNoticeConfig);
                    }
                });
            }
        },
        handleEmailVerify(userNoticeConfig) {
            this.$prompt(`请登录邮箱，在邮箱中点击链接完成认证，如若未收到认证链接，请点击重发按钮\n您的邮箱号为 ${userNoticeConfig.noticeAccount}`, '账号认证', {
                confirmButtonText: '重发',
                cancelButtonText: '取消',
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showInput: false,
                distinguishCancelAndClose: false
            }).then(({ value }) => {
                resendAuthenticationInfo(userNoticeConfig).then(result => {
                    if (result.code === 200) {
                        message.success(result.message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'warning',
                    message: '账号未认证，系统不会发送预警通知消息'
                });
            });
        },
        handleSmsVerify(userNoticeConfig) {
            console.log(userNoticeConfig);
            this.$prompt(`请输入手机号为 ${userNoticeConfig.noticeAccount} 的验证码`, '账号认证', {
                confirmButtonText: '确定',
                cancelButtonText: '重发',
                inputPattern: REGEXP_CODE_SIX,
                inputErrorMessage: '请输入正确验证码',
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                distinguishCancelAndClose: false
            }).then(({ value }) => {
                verifyAccount(userNoticeConfig.id, value).then(result => {
                    if (result.code === 200) {
                        message.success(result.message);
                        this.getList();
                    }
                });
            }).catch(() => {
                resendAuthenticationInfo(userNoticeConfig).then(result => {
                    if (result.code === 200) {
                        message.success('重发成功');
                    }
                });
            });
        },
        handleAccountVerify(row) {
            queryUserNoticeConfigList({ noticeAccount: row.noticeAccount }).then(result => {
                if (result.code === 200) {
                    let userNoticeConfig = result.data.result[0];
                    if (userNoticeConfig.authentication) {
                        return;
                    }
                    // 根据不同的账号类型，进行认证
                    switch (userNoticeConfig.noticeAccountType) {
                        case 'EMAIL':
                            this.handleEmailVerify(userNoticeConfig);
                            break;
                        case 'SMS':
                            this.handleSmsVerify(userNoticeConfig);
                            break;
                        case 'QQ':
                            message.error('暂不支持QQ认证，请直接添加机器人为好友即可');
                            break;
                        default:
                            message.error('未知通知账号类型');
                            break;
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否确认删除"' + row.noticeAccount + '"的数据项？').then(function() {
                return deleteUserNoticeConfig(row);
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        }
    }
};
</script>
<style>

</style>